export const isHydrationError = (error: unknown): error is Error => {
  return !!(error instanceof Error && isHydrationMessage(error.message));
};

export const isHydrationMessage = (message: string) => {
  return !!(
    /** @see https://reactjs.org/docs/error-decoder.html?invariant=418 */
    (
      message.match('Hydration failed because') ||
      message.match('Minified React error #418') ||
      message.match('error while hydrating') ||
      /** @see https://reactjs.org/docs/error-decoder.html?invariant=422 */
      message.match('Minified React error #422') ||
      /** @see https://reactjs.org/docs/error-decoder.html?invariant=423 */
      message.match('Minified React error #423')
    )
  );
};
